import { ReferenceArea, ReferenceLine } from "recharts";
import { Grid, Typography } from "@material-ui/core";

import { GanttChart } from "../../../../../components/charts/GanttChart";
import { RoundIconScatter } from "../../../../../components/charts/GanttChart/RoundIconScatter";
import { assetDetailActivitiesDataNormalizer } from "./assetDetailActivitiesDataNormalizer";
import { COLORS } from "../../../../../theme/colors";
import { CurrentDateCustomLabel } from "./CurrentDateCustomLabel";

const NOW_TIMESTAMP = new Date().getTime();
const tick = { fill: COLORS.darks[0][100] };

const tickFormatter = (x) => {
  const date = new Date(x);

  return `${date.getFullYear()}-${date.getMonth() + 1}`;
};

export const AssetDetailActivities = ({ powerAssetActivities }) => {
  const dates = powerAssetActivities.map((asset) => new Date(asset.date).getTime());
  const firstDate = new Date(Math.min(...dates)).getTime();

  return (
    <Grid container spacing={3}>
      <Grid item>
        <Typography variant="h5">Recent Activity</Typography>
      </Grid>
      <Grid item xs={12} style={{ height: 344 }}>
        <GanttChart
          xAxisKey="date"
          xAxisType="number"
          yAxisKey="height"
          yAxisType="number"
          shape={RoundIconScatter}
          data={powerAssetActivities}
          dataNormalizer={assetDetailActivitiesDataNormalizer}
          tick={tick}
          tickFormatter={tickFormatter}
          backgroundComponents={[
            <ReferenceArea
              key="reference-area"
              x1={firstDate}
              x2={NOW_TIMESTAMP}
              y1={0}
              y2={180}
              ifOverflow="extendDomain"
              fill={COLORS.gray[0]}
            />,
          ]}
          foregroundComponents={[
            <ReferenceLine
              key="reference-line"
              x={NOW_TIMESTAMP}
              stroke={COLORS.black}
              strokeDasharray={10}
              strokeWidth={2}
              label={<CurrentDateCustomLabel />}
            />,
          ]}
        />
      </Grid>
    </Grid>
  );
};
